
export default [
    {
        path: '/',
        meta: { authRequired: true },
        name: 'home',
        component: () => import('./views/home'),
    },
    {
        path: '/login',
        name: 'login',
        meta: { authRequired: false },
        component: () => import('./views/account/login'),
    },
    {
        path: '/authenticator',
        name: 'twoFaPage',
        meta: { authRequired: false },
        component: () => import('./views/account/2fa'),
    },
    {
        path: '/logout',
        name: 'logout',
        meta: { authRequired: true },
        component: () => import('./views/account/logout'),
    },
    {
        path: '/sites/list',
        name: 'sites',
        meta: { authRequired: true },
        component: () => import('./views/sites/Sites'),
    },
    {
        path: '/sites/users',
        name: 'users',
        meta: { authRequired: true },
        component: () => import('./views/sites/Users'),
    },
    {
        path: '/accounts/bank-accounts',
        name: 'bankAccounts',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/BankAccounts'),
    },
    {
        path: '/accounts/mefete-accounts',
        name: 'mefeteAccounts',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/MefeteAccounts'),
    },
    {
        path: '/accounts/pep-accounts',
        name: 'mefeteAccounts',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/PepAccounts'),
    },
    {
        path: '/accounts/groups',
        name: 'groups',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/Groups'),
    },
    {
        path: '/accounts/mails',
        name: 'mailes',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/Mailes'),
    },
    {
        path: '/accounts/answers',
        name: 'answers',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/Answers'),
    },
    {
        path: '/accounts/answers-withdrawals',
        name: 'answers',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/AnswersWithdrawal.vue'),
    },
    {
        path: '/deposits',
        name: 'deposits',
        meta: { authRequired: true },
        component: () => import('./views/deposits/Deposits.vue'),
    },
    {
        path: '/settings/admin-groups',
        name: 'admin-groups',
        meta: { authRequired: true },
        component: () => import('./views/admins/AdminGroups'),
    },
    {
        path: '/settings/admins',
        name: 'administrators',
        meta: { authRequired: true },
        component: () => import('./views/admins/Admins'),
    },
    {
        path: '/withdrawals',
        name: 'withdrawals',
        meta: { authRequired: true },
        component: () => import('./views/withdrawals/Withdrawals'),
    },
    {
        path: '/panel-two/bank-accounts',
        name: 'bankAccountsPanelTwo',
        meta: { authRequired: true },
        component: () => import('./views/bank-accounts/BankAccountsTwo'),
    },
    {
        path: '/panel-two/deposits',
        name: 'depositsPanelTwo',
        meta: { authRequired: true },
        component: () => import('./views/depositsPanelTwo'),
    },
    {
        path: '/black-list/list',
        name: 'depositsPanelTwo',
        meta: { authRequired: true },
        component: () => import('./views/black-list/BlackList.vue'),
    },
    {
        path: '/reports',
        name: 'Reports',
        meta: { authRequired: true },
        component: () => import('./views/reports/Reports.vue'),
    },

]